var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-badge",
        { attrs: { value: _vm.total > 99 ? 99 + "+" : _vm.total } },
        [
          _c(
            "el-popover",
            { attrs: { placement: "bottom", width: "200", trigger: "click" } },
            [
              _c(
                "div",
                {
                  attrs: { slot: "reference" },
                  on: {
                    click: function ($event) {
                      return _vm.getNewList()
                    },
                  },
                  slot: "reference",
                },
                [_c("vab-icon", { attrs: { icon: "notification-line" } })],
                1
              ),
              _c(
                "div",
                { staticClass: "messageList" },
                _vm._l(_vm.messageList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "messageList-item",
                      on: {
                        click: function ($event) {
                          return _vm.goto(item)
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(item.desc) + " "),
                      _c("el-button", { attrs: { type: "text" } }, [
                        _vm._v("(" + _vm._s(item.count) + ")"),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }